module.exports = __webpack_public_path__ + "assets/flags/si.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/si.svg
// module id = 511
// module chunks = 0